export default class CartItem {

    constructor(attributes) {
        Object.assign(this, {
            price: 0,
            priceTableItem: null,
            quantity: 0,
            product: null
        }, attributes);

        if(this.quantity === 0 && this.product !== null) {
            this.setAttributesByProduct(this.product);
        }
    }

    setAttributesByProduct(product) {
        const minQuantity = product.getMinimalQuantity();
        this.quantity = minQuantity;
        this.price = product.getPriceForQuantity(minQuantity);
        this.priceTableItem = product.getPriceTableByQuantity(minQuantity);
    }

    update(attributes) {
        if(attributes.hasOwnProperty('quantity')) {
            const maxQuantity = this.product.getMaximalQuantity();
            if(attributes.quantity <= maxQuantity) {
                this.quantity = attributes.quantity;
                this.refresh();
            }
        }
    }

    refresh() {
        this.quantity = parseInt(this.quantity);
        this.price = this.product.getPriceForQuantity(this.quantity);
        this.priceTableItem = this.product.getPriceTableByQuantity(this.quantity);
    }


}
